import * as yup from "yup";

export const forgot_password_schema = {
  username: "",
};

export const forgot_password_validation_schema = yup.object().shape({
  username: yup.string().required("user_name_required"),
});
